export default __webpack_public_path__ + "static/media/diagnostic.6ea25668.svg";